import Carousel from "react-bootstrap/Carousel";

const SectionOne = () => {
  const heroImages = [
    {
      src: "/hero/hero-1.jpg",
      alt: "جفون للبصريات — نظارة تفرض حضورك وتعكس شخصيتك",
    },
    {
      src: "/hero/hero-2.jpg",
      alt: "جفون للبصريات — نختار لهم الأفضل لعيونهم",
    },
    {
      src: "/hero/hero-3.jpg",
      alt: "جفون للبصريات — اختيارك لنظارتك مو عادي",
    },
  ];

  return (
    <section className="hero-carousel-wrapper" aria-label="معرض الصور الرئيسي">
      <Carousel
        className="hero-carousel"
        fade
        interval={6000}
        indicators
        controls
        pause="hover"
      >
        {heroImages.map((image, index) => (
          <Carousel.Item key={image.src}>
            <div className="hero-image-container">
              <img
                src={image.src}
                alt={image.alt}
                className="hero-image"
                width={2048}
                height={852}
                loading={index === 0 ? "eager" : "lazy"}
                fetchPriority={index === 0 ? "high" : "low"}
                decoding="async"
              />
            </div>
          </Carousel.Item>
        ))}
      </Carousel>

      <style>{`
        .hero-carousel-wrapper {
          width: 100%;
          max-width: none;
          margin: 0;
          position: relative;
          overflow: hidden;
          background: #050505;
        }

        .hero-carousel {
          width: 100%;
          position: relative;
          z-index: 1;
        }

        .hero-carousel .carousel-inner,
        .hero-carousel .carousel-item {
          overflow: hidden;
          background: #050505;
        }

        .hero-image-container {
          width: 100%;
          position: relative;
          overflow: hidden;
          background: #050505;
          aspect-ratio: 1024 / 426;
        }

        .hero-image {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: contain;
          object-position: center center;
          image-rendering: auto;
          -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
          transform: translateZ(0);
        }

        .hero-carousel .carousel-control-prev,
        .hero-carousel .carousel-control-next {
          width: 46px;
          height: 46px;
          background: rgba(10, 10, 10, 0.72);
          border-radius: 50%;
          top: 50%;
          transform: translateY(-50%);
          backdrop-filter: blur(10px);
          opacity: 0.95;
          border: 1px solid rgba(201, 162, 39, 0.45);
          transition: background 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
        }

        .hero-carousel .carousel-control-prev:hover,
        .hero-carousel .carousel-control-next:hover {
          background: rgba(201, 162, 39, 0.92);
          border-color: #E0C15A;
          opacity: 1;
          box-shadow: 0 0 22px rgba(201, 162, 39, 0.4);
        }

        .hero-carousel .carousel-control-prev {
          right: 18px;
          left: auto;
        }

        .hero-carousel .carousel-control-next {
          left: 18px;
          right: auto;
        }

        .hero-carousel .carousel-control-prev-icon,
        .hero-carousel .carousel-control-next-icon {
          width: 18px;
          height: 18px;
          filter: none;
        }

        .hero-carousel .carousel-indicators {
          bottom: 14px;
          margin-bottom: 0;
          z-index: 5;
          gap: 6px;
        }

        .hero-carousel .carousel-indicators button {
          width: 28px;
          height: 3px;
          border-radius: 99px;
          background: rgba(255, 255, 255, 0.35);
          border: none;
          margin: 0;
          opacity: 1;
          transition: width 0.3s ease, background 0.25s ease, box-shadow 0.25s ease;
        }

        .hero-carousel .carousel-indicators button.active {
          width: 42px;
          background: linear-gradient(90deg, #E0C15A, #C9A227);
          box-shadow: 0 0 12px rgba(201, 162, 39, 0.55);
        }

        @media (max-width: 767px) {
          .hero-image-container {
            aspect-ratio: 1024 / 426;
          }

          .hero-carousel .carousel-control-prev,
          .hero-carousel .carousel-control-next {
            width: 32px;
            height: 32px;
          }

          .hero-carousel .carousel-control-prev {
            right: 8px;
          }

          .hero-carousel .carousel-control-next {
            left: 8px;
          }

          .hero-carousel .carousel-control-prev-icon,
          .hero-carousel .carousel-control-next-icon {
            width: 13px;
            height: 13px;
          }

          .hero-carousel .carousel-indicators {
            bottom: 10px;
          }

          .hero-carousel .carousel-indicators button {
            width: 18px;
          }

          .hero-carousel .carousel-indicators button.active {
            width: 28px;
          }
        }
      `}</style>
    </section>
  );
};

export default SectionOne;
